import { useLang } from "@/context/AppContext";

export const LangSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex rounded-full border border-white/10 p-0.5 font-mono text-[11px]">
      {["es", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-switcher-${l}`}
          onClick={() => setLang(l)}
          className={`rounded-full px-2.5 py-1 uppercase tracking-widest transition-colors duration-200 ${lang === l ? "bg-emerald-500 text-slate-950" : "text-slate-400 hover:text-white"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
